/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ValidateIntegrationSourceCodeRequest
 */
export interface ValidateIntegrationSourceCodeRequest {
    /**
     * 
     * @type {string}
     * @memberof ValidateIntegrationSourceCodeRequest
     */
    runtimeType?: string;
    /**
     * 
     * @type {string}
     * @memberof ValidateIntegrationSourceCodeRequest
     */
    sourceCode?: string;
}

/**
 * Check if a given object implements the ValidateIntegrationSourceCodeRequest interface.
 */
export function instanceOfValidateIntegrationSourceCodeRequest(value: object): value is ValidateIntegrationSourceCodeRequest {
    return true;
}

export function ValidateIntegrationSourceCodeRequestFromJSON(json: any): ValidateIntegrationSourceCodeRequest {
    return ValidateIntegrationSourceCodeRequestFromJSONTyped(json, false);
}

export function ValidateIntegrationSourceCodeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidateIntegrationSourceCodeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'runtimeType': json['runtimeType'] == null ? undefined : json['runtimeType'],
        'sourceCode': json['sourceCode'] == null ? undefined : json['sourceCode'],
    };
}

export function ValidateIntegrationSourceCodeRequestToJSON(json: any): ValidateIntegrationSourceCodeRequest {
    return ValidateIntegrationSourceCodeRequestToJSONTyped(json, false);
}

export function ValidateIntegrationSourceCodeRequestToJSONTyped(value?: ValidateIntegrationSourceCodeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'runtimeType': value['runtimeType'],
        'sourceCode': value['sourceCode'],
    };
}

